import { render, staticRenderFns } from "./GeneralWorkingInfo.vue?vue&type=template&id=5d72d100&scoped=true"
import script from "./GeneralWorkingInfo.vue?vue&type=script&lang=js"
export * from "./GeneralWorkingInfo.vue?vue&type=script&lang=js"
import style0 from "./GeneralWorkingInfo.vue?vue&type=style&index=0&id=5d72d100&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d72d100",
  null
  
)

export default component.exports